<div
    class="flex flex-col lg:flex-row gap-4 w-full min-h-0 flex-1 h-full overflow-hidden border border-surface-200 dark:border-surface-700 rounded-md p-3"
    data-testid="menu-items-editor"
>
    <div class="w-full lg:w-[45%] flex flex-col gap-2 min-h-0 min-w-0 flex-1 basis-0">
        <div class="flex flex-wrap gap-2 shrink-0">
            <p-button
                type="button"
                icon="fa fa-plus"
                [rounded]="true"
                [text]="true"
                size="small"
                [disabled]="locked()"
                [pTooltip]="'menu-items-editor.add-root' | translate"
                tooltipPosition="top"
                (onClick)="addRootItem()"
                data-testid="menu-items-add-root"
            />
            <p-button
                type="button"
                icon="fa fa-sitemap"
                [rounded]="true"
                [text]="true"
                size="small"
                severity="secondary"
                [disabled]="locked() || !canAddChild()"
                [pTooltip]="'menu-items-editor.add-child' | translate"
                tooltipPosition="top"
                (onClick)="addChildItem()"
                data-testid="menu-items-add-child"
            />
            <p-button
                type="button"
                icon="fa fa-copy"
                [rounded]="true"
                [text]="true"
                size="small"
                severity="secondary"
                [disabled]="!treeNodes.length && !selectedNode()"
                [pTooltip]="'menu-items-editor.copy' | translate"
                tooltipPosition="top"
                (onClick)="copySelectedItem()"
                data-testid="menu-items-copy"
            />
            <p-button
                type="button"
                icon="fa fa-paste"
                [rounded]="true"
                [text]="true"
                size="small"
                severity="secondary"
                [disabled]="locked()"
                [pTooltip]="'menu-items-editor.paste' | translate"
                tooltipPosition="top"
                (onClick)="pasteItem()"
                data-testid="menu-items-paste"
            />
            <p-button
                type="button"
                icon="fa fa-trash"
                [rounded]="true"
                [text]="true"
                size="small"
                severity="danger"
                [disabled]="locked() || !selectedNode()"
                [pTooltip]="'menu-items-editor.delete' | translate"
                tooltipPosition="top"
                (onClick)="deleteSelectedItem()"
                data-testid="menu-items-delete"
            />
        </div>

        <p-tree
            class="menu-items-tree w-full border border-surface-200 dark:border-surface-700 rounded-md p-2 min-h-0 flex-1"
            [value]="treeNodes"
            selectionMode="single"
            [selection]="selectedNode()"
            (selectionChange)="onSelectionChange($event)"
            (onNodeUnselect)="clearSelection()"
            [draggableNodes]="!locked()"
            [droppableNodes]="!locked()"
            (onNodeDrop)="onNodeDrop($event)"
            [contextMenu]="treeContextMenu"
            contextMenuSelectionMode="joint"
            (onNodeContextMenuSelect)="onNodeContextMenuSelect($event)"
            data-testid="menu-items-tree"
        >
            <ng-template let-node pTemplate="default">
                @if (node.data?.type === 'header') {
                    <div
                        class="flex justify-between items-center gap-2 py-0.5 min-w-0 w-full"
                        [class.opacity-50]="node.data?.hidden"
                    >
                        <span
                            class="truncate text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider"
                        >
                            {{ displayTitle(node) }}
                        </span>
                        <ng-container *ngTemplateOutlet="typeMeta; context: { $implicit: node }" />
                    </div>
                } @else if (node.data?.type === 'menu') {
                    <div
                        class="flex justify-between items-center gap-2 py-0.5 min-w-0 w-full"
                        [class.opacity-50]="node.data?.hidden"
                    >
                        <div class="flex items-center gap-2 min-w-0 w-full">
                            <i
                                class="fa fa-layer-group shrink-0 w-5 text-center text-primary"
                                aria-hidden="true"
                            ></i>
                            <span
                                class="truncate font-semibold"
                                [class.text-muted-color]="!hasReferencedMenu(node)"
                                [class.italic]="!hasReferencedMenu(node)"
                            >
                                {{ displayTitle(node) }}
                            </span>
                        </div>
                        <ng-container *ngTemplateOutlet="typeMeta; context: { $implicit: node }" />
                    </div>
                } @else {
                    <div
                        class="flex justify-between items-center gap-2 py-0.5 min-w-0 w-full"
                        [class.opacity-50]="node.data?.hidden"
                    >
                        <div class="flex items-center gap-2 w-full">
                            @if (
                                (node.data?.type === 'dropdown' ||
                                    node.data?.type === 'simple' ||
                                    node.data?.type === 'customEntity') &&
                                node.data?.icon
                            ) {
                                <i
                                    [class]="node.data.icon"
                                    class="shrink-0 w-5 text-center"
                                    aria-hidden="true"
                                ></i>
                            } @else {
                                <span class="shrink-0 w-5" aria-hidden="true"></span>
                            }
                            <span class="truncate">{{ displayTitle(node) }}</span>
                        </div>
                        @if (node.data?.type) {
                            <ng-container
                                *ngTemplateOutlet="typeMeta; context: { $implicit: node }"
                            />
                        }
                    </div>
                }
            </ng-template>

            <ng-template #typeMeta let-node>
                <span class="text-xs text-muted-color shrink-0 inline-flex items-center gap-1">
                    @if (node.data?.badge?.text || node.data?.badge?.class) {
                        <span
                            class="px-2 py-0.5 rounded-full text-xs font-bold shrink-0"
                            [ngClass]="node.data.badge.class"
                        >
                            {{ node.data.badge.text }}
                        </span>
                    }
                    <span>({{ displayType(node) }})</span>
                    @if (showPermissionIndicator(node)) {
                        <i
                            class="fa fa-lock"
                            [class.text-muted-color]="isPermissionIndicatorMuted(node)"
                            [class.text-primary]="!isPermissionIndicatorMuted(node)"
                            [pTooltip]="permissionTooltip(node)"
                            tooltipPosition="top"
                            aria-hidden="true"
                        ></i>
                    }
                    @if (showRoleIndicator(node)) {
                        <i
                            class="fa fa-user-shield"
                            [class.text-muted-color]="isRoleIndicatorMuted(node)"
                            [class.text-primary]="!isRoleIndicatorMuted(node)"
                            [pTooltip]="roleTooltip(node)"
                            tooltipPosition="top"
                            aria-hidden="true"
                        ></i>
                    }
                </span>
            </ng-template>
        </p-tree>
        <p-contextMenu #treeContextMenu [model]="contextMenuItems" appendTo="body" />
    </div>

    <div
        class="w-full lg:w-[55%] border border-surface-200 dark:border-surface-700 rounded-md p-3 min-h-0 flex-1 overflow-auto"
    >
        <h3 class="text-sm font-semibold m-0 mb-3">
            {{ 'menu-items-editor.inspector-title' | translate }}
        </h3>
        <app-menu-item-inspector
            [item]="selectedItem()"
            [locked]="locked()"
            [isNestedUnderDropdown]="isNestedUnderDropdown()"
            [excludeMenuId]="currentMenuId"
            (itemChange)="onSelectedItemChange($event)"
            (referencedMenuResolved)="onReferencedMenuResolved($event)"
        />
    </div>
</div>
